import { ListChannelFilterActionHandler } from '../../../Business/epg/actionHandlers/ListChannelFilterActionHandler';
import { ListDayFilterActionHandler } from '../../../Business/epg/actionHandlers/ListDayFilterActionHandler';
import { ListTagFilterActionHandler } from '../../../Business/epg/actionHandlers/ListTagFilterActionHandler';
import { IFiltersInfo, ListGroupBy } from '../../../Business/epg/EpgListDataSource';
import { ListAccessibilityFilterActionHandler } from '../../../Business/epg/actionHandlers/ListAccessibilityFilterActionHandler';

/**
 * @enum {string}
 */
export const enum listFilterType {
  channel = 'channel',
  day = 'day',
  tag = 'tag',
  accessibility = 'accessibility',
  all = 'all',
}

export const filterActionMap = {
  [listFilterType.channel]: ListChannelFilterActionHandler,
  [listFilterType.day]: ListDayFilterActionHandler,
  [listFilterType.tag]: ListTagFilterActionHandler,
  [listFilterType.accessibility]: ListAccessibilityFilterActionHandler,
};

type filterStateSubscription = (l: listFilterType, value: any) => void;

export class FilterState {
  private types: listFilterType[];
  private subscriptions: filterStateSubscription[];
  filters: { [key in listFilterType]?: any };
  private readonly _initialState: { [key in listFilterType]?: any };

  constructor(init = {}) {
    this.types = [];
    this.subscriptions = [];
    this.filters = {};
    this._initialState = init;
  }

  subscribe(cb: filterStateSubscription) {
    this.subscriptions.push(cb);
  }

  unsubscribe(cb: filterStateSubscription) {
    this.subscriptions = this.subscriptions.filter(cb1 => cb1 !== cb);
  }

  add(type: listFilterType) {
    if (!this.types.includes(type)) {
      this.types.push(type);
      this.filters[type] = this._initialState[type] ? this._initialState[type] : undefined;
    }
  }

  filtersSet() {
    return Object.keys(this.filters).length > 0;
  }

  reset() {
    this.filters = {};
    this.subscriptions.forEach(cb => cb(listFilterType.all, undefined));
  }

  updateState(type: listFilterType, stateName: string | undefined, value: any) {
    this.filters[type] = { text: stateName, value };
    this.subscriptions.forEach(cb => cb(type, this.filters[type]));
  }

  stateOf(type: listFilterType) {
    return this.filters[type];
  }

  get state(): IFiltersInfo {
    const channel = this.stateOf(listFilterType.channel)?.value;
    const day = this.stateOf(listFilterType.day)?.value;
    const tags = this.stateOf(listFilterType.tag)?.value;
    const accessibility = this.stateOf(listFilterType.accessibility)?.value;
    return {
      groupBy: channel ? ListGroupBy.day : ListGroupBy.channel,
      channel: channel,
      date: day,
      categories: tags,
      accessibility: accessibility,
    };
  }
}
